import './assets/shared.css';const o = "_surface_x9igk_16", a = "_backdrop_x9igk_21", _ = "_overlay_x9igk_25", c = "_dialog_x9igk_48", r = {
  surface: o,
  backdrop: a,
  overlay: _,
  dialog: c
};
export {
  r as s
};
